import { createNamespacedHelpers } from "vuex";

const navig = navigator;

const GARNISH_IMAGE_SIZE = "144x144";
const GARNISH_IMAGE_FULL = "600x600";
const GARNISH_IMAGE_QUALITY = 70;

/**
 * shared between the menu row and the global booking dialog.
 * the component supplies item / discount / categoryId, as a prop in the row and
 * as a computed in the dialog.
 */
export default {
  data() {
    return {
      brokenGarnishImages: {}
    };
  },

  computed: {
    ...createNamespacedHelpers("Order").mapGetters(["card"]),
    ...createNamespacedHelpers("Config").mapGetters([
      "Images",
      "imageServerBaseUrl",
      "imageServerImagePath",
      "isReadonly",
      "isAycePerGroupMode",
      "ayceLockedGroupIds",
      "ayceGroupTimerFormatted"
    ]),

    // true when this item's group is currently in cooldown
    isThisGroupLocked() {
      return (
        this.isAycePerGroupMode &&
        this.categoryId !== null &&
        this.categoryId !== undefined &&
        this.ayceLockedGroupIds.includes(Number(this.categoryId))
      );
    },

    hasSize() {
      return Array.isArray(this.item?.sizes) && this.item.sizes.length > 0;
    },

    isItemHasExtras() {
      return (
        this.hasSize ||
        (Array.isArray(this.item?.extras) && this.item.extras.length > 0)
      );
    },

    itemDiscount() {
      if (!Number.isNaN(parseFloat(this.item?.discount)))
        return parseFloat(this.item.discount).toFixed(2);
      else if (!Number.isNaN(parseFloat(this.discount)))
        return parseFloat(this.discount).toFixed(2);
      else return 0;
    },

    itemDeposit() {
      return this.item?.deposit?.price
        ? parseFloat(this.item.deposit.price)
        : 0;
    }
  },

  methods: {
    vibrate() {
      navigator.vibrate =
        navigator.vibrate ||
        navigator.webkitVibrate ||
        navigator.mozVibrate ||
        navigator.msVibrate;

      if (navigator.vibrate) navig.vibrate(90);
    },

    // both guards return true when the action has to stop
    blockedByGroupLock() {
      if (!this.isThisGroupLocked) return false;

      this.$swal({
        title: this.$t("generic.lang_groupLockedTitle"),
        text: this.$t("generic.lang_groupLockedText", {
          time: this.ayceGroupTimerFormatted(this.categoryId)
        }),
        icon: "info"
      });
      return true;
    },

    blockedByOncePerOrder(item) {
      if (!item || !item.canBeSoldOncePerOrder) return false;
      if (!this.card.some(element => element.item.id === item.id)) return false;

      this.$swal({
        title: this.$t("generic.lang_thisItemCanOnlyBeSoldOncePerOrder"),
        icon: "info"
      });
      return true;
    },

    showGarnishImages(tab) {
      return !!(tab && tab.showImagesInTableBee);
    },

    // garnish images come as bare file names, thumbor builds the final url
    garnishImage(ext) {
      if (!ext || !ext.image || this.brokenGarnishImages[ext.id]) return null;
      if (/^https?:\/\//i.test(ext.image)) return ext.image;

      // cache is non reactive on purpose, the url only depends on ext.id
      const cache = this._garnishUrlCache || (this._garnishUrlCache = {});
      if (cache[ext.id]) return cache[ext.id];

      const base = (this.imageServerBaseUrl || "").replace(/\/+$/, "");
      const path = (this.imageServerImagePath || "").replace(/^\/+|\/+$/g, "");
      if (!base) return null;

      cache[
        ext.id
      ] = `${base}/${GARNISH_IMAGE_SIZE}/filters:quality(${GARNISH_IMAGE_QUALITY})/${path}/${ext.image}`;
      return cache[ext.id];
    },

    // bigger thumbor render, only used by the lightbox
    garnishImageFull(ext) {
      const thumb = this.garnishImage(ext);
      if (!thumb) return null;
      return thumb.replace(
        `/${GARNISH_IMAGE_SIZE}/`,
        `/${GARNISH_IMAGE_FULL}/`
      );
    },

    garnishInitial(ext) {
      return ext && ext.name
        ? ext.name
            .trim()
            .charAt(0)
            .toUpperCase()
        : "";
    },

    markGarnishImageBroken(ext) {
      if (ext) this.$set(this.brokenGarnishImages, ext.id, true);
    },

    openImage(src, alt) {
      if (!src) return;
      this.$root.$emit("showImage", { src, alt });
    }
  }
};
